import React, { useState, useEffect, useContext } from "react"

import CourseCard from "../components/cards/CourseCard"
import CardTag from "../components/cards/CardTag"
import { Context } from "../../.."

import { wordNumDeclention } from "../utils"

const TeachersCabinetContent = () => {
    const { user } = useContext(Context)
    const [courses, setCourses] = useState([])

    useEffect(() => {
        (async () => {
            try {
                const resp = await fetch(`/api/teachers/courses`);
                const data = await resp.json();
                console.log("Ответ API:", data); // Логируем ответ
                setCourses(Array.isArray(data) ? data : []); // Убедимся, что это массив
            } catch (e) {
                console.error(e);
                setCourses([]); // Если ошибка, сбрасываем в пустой массив
            }
        })();
    }, [user.user.id]);


    return (
        <section className="py-10 px-11 w-full">
            <div className="mb-16 flex gap-8">
                <span>Курсы</span>
                <span className="text-blue-gray-30">/</span>
                <span className="text-blue-gray-30">Всего {courses.length || 0} {wordNumDeclention(courses.length, 'course')}</span>
            </div>
            <div className="flex flex-wrap gap-2">
                {courses && courses.map(c => (
                    <CourseCard link={`course/${c.id}`} title={c.title} description={c.description} key={c.id} optionsEnabled={false}>
                        {c.paragraphs && <CardTag text={`${c.paragraphs.length} ${wordNumDeclention(c.paragraphs.length, 'paragraph')}`} />}
                    </CourseCard>
                ))}
            </div>
        </section>
    )
}

export default TeachersCabinetContent